
export const promoTxt = {
    0: {
        txt: '指定影片影院限时限量立减',
        tip: '惠',
        logogram: '优惠立减',
        logogram1: '已减',
        backColor: '#F56A00'
    }, // 促销立减
    1: {
        txt: '指定影片影院限时限量特价',
        tip: '降',
        logogram: '特惠',
        logogram1: '已优惠',
        backColor: '#27BD4E'
    }, // 一口价
    2: {
        txt: '新用户指定影片影院限时限量立减',
        tip: '新',
        logogram: '新人专享',
        logogram1: '新户立减',
        backColor: '#27BD4E'
    }, // 首单立减
    3: {
        txt: '限时特惠！购买指定影片限量抢购',
        tip: '抢',
        logogram: '限时抢购',
        backColor: '#F56A00'
    }, // 限时抢购
    4: {
        txt: '限时特惠！购买指定影片秒杀价',
        tip: '秒',
        logogram: '单品秒杀',
        backColor: '#F56A00'
    } // 单品秒杀
};
